import { render } from "./403.vue?vue&type=template&id=c4e2a1da&scoped=true"
const script = {}

import "./403.vue?vue&type=style&index=0&id=c4e2a1da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4e2a1da"]])

export default __exports__